import { render, staticRenderFns } from "./STablePurchasesComp.vue?vue&type=template&id=72c40d92&"
import script from "./STablePurchasesComp.vue?vue&type=script&lang=js&"
export * from "./STablePurchasesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports